/**
 * Shared constants for NMP Loader
 */

export const LOADER_TYPES = {
  SYSTEMJS: 'systemjs',
  FEDERATION: 'federation',
} as const;

export const BUNDLE_TYPES = {
  UMD: 'umd',
  GLOBAL: 'global',
  MODULE_FEDERATION: 'module-federation',
} as const;

export const MODULE_FEDERATION = {
  DEFAULT_EXPOSED_MODULE: './Module',
  DEFAULT_VERSION: '15.2.9',
  SHARE_SCOPE_FROM: 'host',
} as const;

export const HTTP_CONFIG = {
  AUTHORIZATION: 'any string forces cookies',
  CROSS_ORIGIN: 'use-credentials',
} as const;

export const LOG_PREFIXES = {
  NMP_LOADER: '[nmp-loader]',
  SHARE_SCOPE: '[share-scope]',
} as const;

export const ERROR_MESSAGES = {
  MODULE_NOT_FOUND: 'Cannot find module with such name on registry',
  REMOTE_ENTRY_LOAD_FAILED: 'Failed to load remote entry',
  REMOTE_CONTAINER_NOT_FOUND: 'not found on window',
  REMOTE_NAME_EXTRACTION_FAILED:
    'Cannot determine remote container name from URL',
} as const;

export const MODULE_FEDERATION_CONFIG = {
  MUNI_PREFIX: 'Muni',
} as const;

/**
 * Get list of modules for Module Federation share scope
 * Note: @angular/compiler is intentionally excluded to avoid SystemJS frozen module issues
 */
export const getModuleFederationSharedModules = (): string[] => [
  '@angular/core',
  '@angular/common',
  '@angular/common/http',
  '@angular/platform-browser',
  '@angular/platform-browser-dynamic',
  '@angular/platform-browser/animations',
  '@angular/router',
  '@angular/forms',
  '@angular/animations',
  '@angular/animations/browser',
  '@angular/cdk',
  '@angular-slider/ngx-slider',
  'rxjs',
  'rxjs/operators',
  'tslib',
  '@ipreo/northstar',
  '@ipreo/cupcake-components',
  '@ipreo/ngx-sprinkles',
  '@ipreo/muni-shared',
  '@ipreo/muni-bidcomp-shared',
  '@ngrx/store',
  '@ngrx/effects',
  '@ngrx/router-store',
  'oidc-client',
  'ag-grid-angular',
  'ag-grid-community',
  'ag-grid-enterprise',
];

// Type exports for use in interfaces
export type LoaderType =
  | typeof LOADER_TYPES.SYSTEMJS
  | typeof LOADER_TYPES.FEDERATION;
export type BundleType =
  | typeof BUNDLE_TYPES.UMD
  | typeof BUNDLE_TYPES.GLOBAL
  | typeof BUNDLE_TYPES.MODULE_FEDERATION;
